export default __webpack_public_path__ + "static/media/15B76CE8-0185-4200-8970-9AAE521F2C5A_1_105_c.20a1bc29.jpeg";